module.exports = __webpack_public_path__ + "media/story_video.beca0651.mp4";